import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyOptionSelectionChange as MatOptionSelectionChange } from '@angular/material/legacy-core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NewPermission } from '@core/enums/permission';
import { Store } from '@ngxs/store';
import { RelatedToType } from '@shared/enums';
import { UserState } from '@state/user/state';
import { AccountService } from 'app/core';
import { ReportingService } from 'app/modules/reporting/reporting.service';
import { ReportLayoutRelatedToType } from 'app/modules/reporting/reporting.types';
import { ReportType } from 'app/modules/reports/reports.types';

@Component({
  selector: 'app-reporting-create-modal',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportingCreateModalComponent {
  form = new FormGroup({
    relatedToType: new FormControl<string>(null, [Validators.required]),
    name: new FormControl<string>('', [Validators.required]),
    report_type: new FormControl<string>(ReportType.SingleObject, []),
  });

  relatedToTypes: ReportLayoutRelatedToType[] = [];
  showTimeSeriesOption = false;

  constructor(
    private readonly matDialogRef: MatDialogRef<ReportingCreateModalComponent>,
    private readonly reportingService: ReportingService,
    private readonly accountService: AccountService,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.reportingService
      .getReportLayoutRelatedToTypesByAccount(this.accountService.getCurrentAccount().id)
      .subscribe((relatedToTypes: ReportLayoutRelatedToType[]) => {
        const relatedToTypesPerission = {
          [RelatedToType.Project]: NewPermission.DEALS_VIEW,
        };

        this.relatedToTypes = relatedToTypes.filter(({ type }) => {
          if (!relatedToTypesPerission[type]) {
            return true;
          }
          return this.store.selectSnapshot(UserState.hasPermission(relatedToTypesPerission[type]));
        });
      });
  }

  create(): void {
    const model = this.form.getRawValue();

    if (!this.relatedToTypes.find(({ type }) => type === model.relatedToType)?.time_series) {
      model.report_type = ReportType.SingleObject;
    }

    this.matDialogRef.close(model);
  }

  discard(): void {
    this.matDialogRef.close();
  }

  relatedToTypeChanged(event: MatOptionSelectionChange<string>): void {
    this.showTimeSeriesOption =
      this.relatedToTypes.find(({ type }) => type === event.source.value)?.time_series === true;

    if (!this.showTimeSeriesOption) {
      this.form.get('report_type').setValue(ReportType.SingleObject);
    }
  }
}
